/*==========================
 社群網站的button
 參考 AngularJS directives for social sharing buttons - Facebook Like, Google+, Twitter and Pinterest
 >> http://jasonwatmore.com/post/2014/08/01/AngularJS-directives-for-social-sharing-buttons-Facebook-Like-GooglePlus-Twitter-and-Pinterest.aspx
 >> https://github.com/cornflourblue/angulike)
 Author : Alan
 最後更新時間 : 2014 / 10 / 30
==========================*/

// --------------------- 根據 api自動產生分享按鈕 ------------------------ //

// window.InifECApp.directive('fbShareButton', ['$http', '$timeout', 'fbconfig', function($http, $timeout, fbconfig) {
// 	return {
// 		restrict: "A",
// 		scope: {
// 			url: "="
// 		},
// 		link: function(scope, elem, attrs) {

// 			var currentUrl = undefined;
			

// 			var createHTML = function(url) {
				
// 				return `
// 					<div class="fb-share-button" data-href="` + url + `" data-layout="button_count" data-size="small" data-mobile-iframe="true"></div>
// 				`;
// 			}

// 	       	var init = function(currentUrl) {
       	        
//        	        elem.html(createHTML(currentUrl));

//        	        if(window.FB && window.FB.XFBML && window.FB.XFBML.parse) {
//        	            window.FB.XFBML.parse(elem[0]);    
//        	        }
// 	       	}

//             scope.$watch("url", function(newValue, oldValue) {
//             	if(newValue){
//             		$timeout(function(){
//             			if(!currentUrl || currentUrl != newValue) {
//             				currentUrl = newValue;
// 	                		init(currentUrl);
// 	                	}
// 	                }, 1000);
// 	            }
//             });
// 		}
// 	}
// }]);

window.InifECApp.directive('fbShareButton', ['$http', 'fbconfig', function($http, fbconfig) {
	return {
		restrict: "E",
		scope: {
			url: "="
		},
		link: function(scope, element, attrs) {

			var currentUrl = undefined;

			var init = function(){
				if(!scope.url){
					scope.url = window.location.href;
				}

				renderLikeButton();
				
				// if (!window.FB) {
    //                 // Load Facebook SDK if not already loaded
    //                 $.getScript('//connect.facebook.net/zh_TW/sdk.js', function () {
    //                     	window.FB.init({
    //                         	appId: fbconfig.appId,
    //                         	xfbml: true,
    //                         	version: 'v2.2'
    //                     });
    //                     renderLikeButton();
    //                 });
    //             } else {
    //                 renderLikeButton();
    //             }
			}

			var renderLikeButton = function() {
	            element.html('<div class="fb-like" data-href="' + scope.url + '" data-layout="button_count" data-action="like" data-show-faces="true" data-share="true"></div>');
	            if(window.FB && window.FB.XFBML && window.FB.XFBML.parse) {
	            	window.FB.XFBML.parse(element.parent()[0]);
	            }
	       	}

            scope.$watch("url", function(newValue, oldValue) {
            	if(newValue){
        			if(!currentUrl || currentUrl != newValue) {
        				currentUrl = newValue;
                		init();
                	}
	            }
            });
		}
	}
}]);

window.InifECApp.directive('twitterShareButton', ['$http', function($http) {
	return {
		restrict: "E",
		scope: {
			url: "=",
			text: "=",
		},
		// template: "<a class='sharelizers twitter'><span class='icons-style'><i class='icon-twitter'></i></span><span class='number'>{{twitterShareCount | shareCount}}</span></a>",
		link: function(scope, element, attrs) {

			var init = function(){
				if(!scope.url){
					scope.url = window.location.href;
				}

				if (!window.twttr) {
                    // Load Twitter SDK if not already loaded
                    $.getScript('//platform.twitter.com/widgets.js', function () {
                        renderTweetButton();
                    });
                } else {
                    renderTweetButton();
                }
			}

            var renderTweetButton = function() {
                element.html('<a href="https://twitter.com/share" class="twitter-share-button" data-url="' + scope.url + '" data-text="' + scope.text + '"></a>');
                window.twttr.widgets.load(element.parent()[0]);
            }

            scope.$watch("url", function(newValue, oldValue) {
            	if(newValue){
	                init();
	            }
            });

            scope.$watch("text", function(newValue, oldValue) {
            	if(scope.url && newValue){
	                init();
	            }
            });

		}
	}
}]);

window.InifECApp.directive('googlePlusShareButton', function() {
	return {
		restrict: "E",
		scope: {
			url: "=",
		},
		link: function(scope, element, attrs) {

			var init = function(){
				if(!scope.url){
					scope.url = window.location.href;
				}

				if (!window.gapi) {
	                // Load Google SDK if not already loaded
	                $.getScript('//apis.google.com/js/platform.js', function () {
	                    renderPlusButton();
	                });
	            } else {
	                renderPlusButton();
	            }
			}

            var renderPlusButton = function() {
                element.html('<div class="g-plus" data-action="share" data-annotation="bubble" data-href="' + scope.url +'"></div>');
                window.gapi.plus.go(element.parent()[0]);
            }

			scope.$watch("url", function(newValue, oldValue) {
            	if(newValue){
	                init();
	            }
            });
		}
	}
});

window.InifECApp.directive('linkedinShareButton', function() {
	return {
		restrict: "E",
		scope: {
			url: "=",
		},
		link: function(scope, element, attrs) {

			var init = function(){
				if(!scope.url){
					scope.url = window.location.href;
				}

				if (!window.IN) {
	                // Load Linked SDK if not already loaded
	                $.getScript('http://platform.linkedin.com/in.js', function (data) {
	                    renderPlusButton();
	                });
	            } else {
	                renderPlusButton();
	            }
			}

            var renderPlusButton = function() {
	            element.html('<script type="IN/Share" data-url="' + scope.url + '" data-counter="right"></script>');
	            if(typeof IN.parse == 'function') {
	            	// 如果不加上面這一行判斷都會跳錯誤訊息在console，雖然不影響但是很煩
		            IN.parse();
		        }
            }

			scope.$watch("url", function(newValue, oldValue) {
            	if(newValue){
	                init();
	            }
            });
		}
	}
});

window.InifECApp.directive('pinterestShareButton', function() {
	return {
		restrict: "E",
		scope: {
			url: "=",
			media: "=",
			description: "="
		},
		link: function(scope, element, attrs) {

			var init = function(){
				if(!scope.url){
					scope.url = window.location.href;
				}

				if (!window.parsePins) {
                      // Load Pinterest SDK if not already loaded
                      (function (d) {
                          var f = d.getElementsByTagName('SCRIPT')[0], p = d.createElement('SCRIPT');
                          p.type = 'text/javascript';
                          p.async = true;
                          p.src = '//assets.pinterest.com/js/pinit.js';
                          p['data-pin-build'] = 'parsePins';
                          p.onload = function () {
                              if (!!$window.parsePins) {
                                  renderPinItButton();
                              } else {
                                  setTimeout(p.onload, 100);
                              }
                          };
                          f.parentNode.insertBefore(p, f);
                      }(window.document));
                } else {
                      renderPinItButton();
                }
			}

            var renderPinItButton = function() {
                element.html('<a href="//www.pinterest.com/pin/create/button/?url=' + scope.url + '&media=' + scope.media + '&description=' + scope.description + '" data-pin-do="buttonPin" data-pin-config="beside"><img src="//assets.pinterest.com/images/pidgets/pinit_fg_en_rect_gray_20.png" /></a>');
                window.parsePins(element.parent()[0]);
            }

			scope.$watch("url", function(newValue, oldValue) {
            	if(newValue){
	                init();
	            }
            });

            scope.$watch("media", function(newValue, oldValue) {
            	if(newValue){
	                init();
	            }
            });

            scope.$watch("description", function(newValue, oldValue) {
            	if(newValue){
	                init();
	            }
            });
		}
	}
});

// ---------------------- 以下為分享開新視窗的點擊事件 ----------------------- //

// window.InifECApp.directive('fbShare', ['$http', 'fbconfig', function($http, fbconfig) {
// 	return {
// 		restrict: "A",
// 		link: function(scope, element, attrs) {

// 			element.bind('click', function(){
// 				facebookShareByPopupWindow();
// 			});

// 			var facebookShareByAPI = function() {
// 				if(!window.FB){
// 					return;
// 				}

// 				window.FB.ui({
// 		            method: 'feed',
// 		            // name: product_name,
// 		            link: shareurl
// 		            // picture: share_image,
// 		            // caption: share_capt,
// 		            // description: description
// 		        }, function(response){
// 		        	if(response.post_id){
// 		        		scope.$apply(attrs.fbShareCallback);
// 		        	}
// 		        });
// 			}

// 			var facebookShareByPopupWindow = function(shareurl) {
// 				var shareurl = attrs.fbShare;
// 				if(!shareurl){
// 					shareurl = window.location.href;
// 				}

// 				// var fbshareUrl = 'https://www.facebook.com/dialog/share?'
// 				// 	+ 'app_id=' + fbconfig.appId
// 				// 	+ '&display=popup'
// 				// 	+ '&href=' + window.encodeURIComponent(shareurl)					
// 				// 	+ '&redirect_uri=' + window.encodeURIComponent(shareurl);

// 				var fbshareUrl = 'https://www.facebook.com/sharer/sharer.php?u='
// 					+ window.encodeURIComponent(shareurl);

// 				window.open(fbshareUrl, "fbShareWindow", "status = 1, height = 500, width = 360, resizable = 0" );
// 			}
			
// 		}
// 	}
// }]);

// window.InifECApp.directive('twitterShare', ['$http', function($http) {
// 	return {
// 		restrict: "A",
// 		link: function(scope, element, attrs) {
			
// 			element.bind('click', function(){
// 				twitterShareByPopupWindow();
// 			});

// 			var twitterShareByPopupWindow = function(shareurl) {
// 				var shareurl = attrs.twitterShare,
// 					text = attrs.shareText.replace(/\|/g, "");

// 				if(!shareurl){
// 					shareurl = window.location.href;
// 				}

// 				var twittershareUrl = 'https://twitter.com/intent/tweet?'
// 					+ 'url=' + window.encodeURIComponent(shareurl)
// 					+ '&text=' + text;

// 				window.open(twittershareUrl, "twitterShareWindow", "status = 1, height = 500, width = 360, resizable = 0");
			
// 			}
// 		}
// 	}
// }]);

// window.InifECApp.directive('googlePlusShare', function() {
// 	return {
// 		restrict: "A",
// 		link: function(scope, element, attrs) {

// 			element.bind('click', function(){
// 				var shareurl = attrs.twitterShare;

// 				if(!shareurl){
// 					shareurl = window.location.href;
// 				}

// 				var googlePlusShareUrl = 'https://plus.google.com/u/0/share?'
// 					+ 'url=' + window.encodeURIComponent(shareurl);

// 				window.open(googlePlusShareUrl, "googlePlusShareWindow", "status = 1, height = 500, width = 360, resizable = 0");
// 			});

// 		}
// 	}
// });

// window.InifECApp.directive('pinterestShare', function() {
// 	return {
// 		restrict: "A",
// 		link: function(scope, element, attrs) {
			
// 			element.bind('click', function(){
// 				var shareurl = attrs.twitterShare,
// 					media = attrs.shareMedia,
// 					description = attrs.shareDescription,
// 					is_video = attrs || false;

// 				if(!shareurl){
// 					shareurl = window.location.href;
// 				}

// 				var pinterestShareUrl = 'https://www.pinterest.com/pin/create/button/?'
// 					+ 'url=' + window.encodeURIComponent(shareurl)
// 					+ '&media=' + media
// 					+ '&description=' + description
// 					+ '&is_video' + is_video;

// 				window.open(pinterestShareUrl, "pinterestShareWindow");
// 			});
// 		}
// 	}
// });

// window.InifECApp.directive('linkedinShare', function() {
// 	return {
// 		restrict: "A",
// 		link: function(scope, element, attrs) {
			
// 			element.bind('click', function(){
// 				var shareurl = attrs.twitterShare,
// 					text = attrs.shareText.replace(/\|/g, "");

// 				if(!shareurl){
// 					shareurl = window.location.href;
// 				}

// 				var linkedinShareUrl = 'https://www.linkedin.com/shareArticle?mini=true&'
// 					+ 'url=' + window.encodeURIComponent(shareurl)
// 					+ '&title=' + text;


// 				window.open(linkedinShareUrl, "pinterestShareWindow");
// 			});
// 		}
// 	}
// });

// window.InifECApp.directive('emailShare', function() {
// 	return {
// 		restrict: "A",
// 		link: function(scope, element, attrs) {
			
// 			element.bind('click', function(){
// 				var shareurl = attrs.emailShare,
// 					text = attrs.shareText.replace(/\|/g, "");

// 				if(!shareurl){
// 					shareurl = window.location.href;
// 				}				

// 				var emailShareUrl = 'mailto:?subject='
// 					+ text + '&body=' + text + ', ' + shareurl;

// 				window.open(emailShareUrl, "emailShareUrl");
// 			});
// 		}
// 	}
// });

// window.InifECApp.directive('fbLikeButtonCount', ['$http', '$timeout', 'fbconfig', function($http, $timeout, fbconfig) {
// 	return {
// 		restrict: 'E',
// 		scope: {
// 			url: "="
// 		},
// 		link: function(scope, element, attrs){

// 			var currentUrl = undefined;
			
// 			var init = function(){
// 				if(!scope.url){
// 					scope.url = window.location.href;
// 				}

// 				if (!window.FB) {
//                     // Load Facebook SDK if not already loaded
//                     $.getScript('//connect.facebook.net/zh_TW/sdk.js', function () {
//                         	window.FB.init({
//                             	appId: fbconfig.appId,
//                             	xfbml: true,
//                             	version: 'v2.0',
                           	
//                      }).then(
//                      	renderLikeButton()
//                      );
//                     });
//                 } else {
//                     renderLikeButton();
//                 }
// 			};

// 			var renderLikeButton = function() {
// 	            element.html('<div class="fb-like" data-href="' + scope.url + '" data-layout="button_count" data-action="like" data-show-faces="false" data-share="true" kid_directed_site＝"false"></div>');
// 	            window.FB.XFBML.parse(element.parent()[0]);	            
// 	       	};

// 	       	scope.$watch("url", function(newValue, oldValue) {
//             	if(newValue){
//             		$timeout(function(){
//             			if(!currentUrl || currentUrl != newValue) {
//             				currentUrl = newValue;
// 	                		init();
// 	                	}
// 	                }, 500);
// 	            }
//             });
// 		}
// 	}
// }]);

// window.InifECApp.directive('fbPhpLikeButton',['$http', '$timeout', function($http, $timeout){
// 	return {
// 		restrict: "E",
// 		scope: {
// 			url : "="
// 		},
// 		link: function(scope, element, attrs){
// 			var currentUrl = undefined;
// 			var renderLikeButton = function(){
// 				element.html('<iframe src="http://www.facebook.com/plugins/like.php?href='+ scope.url+
// 					'&layout=button_count&show_faces=true&action=like&colorscheme=light" ></iframe>');
// 			};
// 			renderLikeButton();
// 			scope.$watch("url", function(newValue, oldValue){
// 				if(newValue){
// 					$timeout(function(){
// 						if(!currentUrl || currentUrl != newValue) {
//             				currentUrl = newValue;
// 	                		renderLikeButton();
// 	                	}
// 					}, 500);
// 				}
// 			});
// 		}

// 	}
// }]);